import './Curso.css';

const Curso = () => {
    return (
        <div class="page-width">
            <div class="pai-curso">
                <div class="info-title">
                    <h3>Cursos Complementares</h3>
                </div>
                <div class="agrupe-curso">
                    <div class="info-curso">
                        <h4>Informática Básica</h4>
                        <div class="agrupe-inst">
                            <h5>CUCA (José Walter)</h5>
                            <div class="button">
                                <p>CONCLUÌDO</p>
                            </div>
                        </div>
                        <div class="button-ver-mais">
                            <a href="" target="_blank">
                                <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.82766 11.813L11.813 13.7984L13.7984 11.8131L23.6261 1.98539L21.6407 0L11.813 9.82766L1.98539 8.8086e-06L0 1.98539L9.82766 11.813Z" fill="#D9D9D9" fill-opacity="0.6"/>
                                </svg>
                                <span>CERTIFICADO</span>
                            </a>
                        </div>
                    </div>

                    <div class="info-curso">
                        <h4>Inglês</h4>
                        <div class="agrupe-inst">
                            <h5>imparh</h5>
                            <div class="button">
                                <p>Cursando</p>
                            </div>
                        </div>
                        <div class="button-ver-mais">
                            <a href="" target="_blank">
                                <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.82766 11.813L11.813 13.7984L13.7984 11.8131L23.6261 1.98539L21.6407 0L11.813 9.82766L1.98539 8.8086e-06L0 1.98539L9.82766 11.813Z" fill="#D9D9D9" fill-opacity="0.6"/>
                                </svg>
                                <span>CERTIFICADO</span>
                            </a>
                        </div>
                    </div>

                    <div class="info-curso">
                        <h4>Informática Básica</h4>
                        <div class="agrupe-inst">
                            <h5>Dio Bootcamp - banco pan</h5>
                            <div class="button">
                                <p>CONCLUÌDO</p>
                            </div>
                        </div>
                        <div class="button-ver-mais">
                            <a href="" target="_blank">
                                <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.82766 11.813L11.813 13.7984L13.7984 11.8131L23.6261 1.98539L21.6407 0L11.813 9.82766L1.98539 8.8086e-06L0 1.98539L9.82766 11.813Z" fill="#D9D9D9" fill-opacity="0.6"/>
                                </svg>
                                <span>CERTIFICADO</span>
                            </a>
                        </div>
                    </div>

                    <div class="info-curso">
                        <h4>Informática Básica</h4>
                        <div class="agrupe-inst">
                            <h5>CUCA (José Walter)</h5>
                            <div class="button">
                                <p>CONCLUÌDO</p>
                            </div>
                        </div>
                        <div class="button-ver-mais">
                            <a href="" target="_blank">
                                <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.82766 11.813L11.813 13.7984L13.7984 11.8131L23.6261 1.98539L21.6407 0L11.813 9.82766L1.98539 8.8086e-06L0 1.98539L9.82766 11.813Z" fill="#D9D9D9" fill-opacity="0.6"/>
                                </svg>
                                <span>CERTIFICADO</span>
                            </a>
                        </div>
                    </div>

                    <div class="info-curso">
                        <h4>Discovery</h4>
                        <div class="agrupe-inst">
                            <h5>Rocketseat</h5>
                            <div class="button">
                                <p>CONCLUÌDO</p>
                            </div>
                        </div>
                        <div class="button-ver-mais">
                            <a href="" target="_blank">
                                <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.82766 11.813L11.813 13.7984L13.7984 11.8131L23.6261 1.98539L21.6407 0L11.813 9.82766L1.98539 8.8086e-06L0 1.98539L9.82766 11.813Z" fill="#D9D9D9" fill-opacity="0.6"/>
                                </svg>
                                <span>CERTIFICADO</span>
                            </a>
                        </div>
                    </div>

                    <div class="info-curso">
                        <h4>Imersão Front-End</h4>
                        <div class="agrupe-inst">
                            <h5>Alura</h5>
                            <div class="button">
                                <p>CONCLUÌDO</p>
                            </div>
                        </div>
                        <div class="button-ver-mais">
                            <a href="" target="_blank">
                                <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.82766 11.813L11.813 13.7984L13.7984 11.8131L23.6261 1.98539L21.6407 0L11.813 9.82766L1.98539 8.8086e-06L0 1.98539L9.82766 11.813Z" fill="#D9D9D9" fill-opacity="0.6"/>
                                </svg>
                                <span>CERTIFICADO</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    )
};

export default Curso;